var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "list-deliverable-status-bar",
      style: "background-color:" + _vm.publishStatus.color
    },
    [
      _c("div", { staticClass: "list-deliverable-status-controls" }, [
        _c(
          "div",
          {
            staticClass: "status-bar-button",
            on: { click: _vm.clickDuplicate }
          },
          [_c("i", { staticClass: "fas fa-copy" })]
        ),
        _vm._v(" "),
        _vm.userCanEditDeliverable()
          ? _c(
              "div",
              {
                staticClass: "status-bar-button",
                on: { click: _vm.clickDelete }
              },
              [_c("i", { staticClass: "fas fa-trash" })]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }